import { default as _open } from './open';
import { getToAppName } from './base';
import isAppInstallByName from '../isAppInstallByName';
import openMarket from './openMarket';
import appInfoMap from '../isAppInstall/appInfoMap';
import getAppName from '../getAppName';
import request from '../request';
import storage from '../storage';
import Locale from '@ky/locale';
export default async function open(url, opt = {}) {
    let _url = url;
    let hasInstall = true;
    const hostAppName = getAppName();
    const toAppName = opt.toAppName || getToAppName(url) || hostAppName;
    if (!opt.preventResovleWebUrl && url.startsWith('http')) {
        _url = appInfoMap[toAppName]?.getWebLink?.(url, opt) || url;
    }
    if (hostAppName === toAppName) {
        return _open(_url, opt);
    }
    appInfoMap[toAppName]?.setGuiYin?.(request, {
        activity: opt.guiYinActivity,
        from: opt.guiYinFrom || opt.from,
    });
    if (toAppName === 'kwai') {
        // 跳装快手的，有快手和极速版其中一个就行
        const [isKwaiInstall, isNebulaInstall] = await Promise.all([
            isAppInstallByName('kwai'),
            isAppInstallByName('ksnebula'),
        ]);
        hasInstall = isKwaiInstall || isNebulaInstall;
        if (!isKwaiInstall && isNebulaInstall) {
            _url = _url.replace('kwai://', 'ksnebula://');
        }
    }
    else {
        hasInstall = await isAppInstallByName(toAppName);
    }
    if (hasInstall) {
        if (opt?.confirm && hostAppName === 'kwaiying') {
            const storageKey = `OPEN_${toAppName}_CONFIRM`;
            const storageTable = 'sdk';
            const value = await storage.get(storageTable, storageKey);
            if (value !== '1') {
                await opt?.confirm('security_privacy_tips', Locale.t('stitching', Locale.t('jumpTo'), Locale.t(appInfoMap[toAppName]?.name || 'thirdPartApp')));
                storage.set(storageTable, storageKey, '1');
            }
        }
        return _open(_url, { ...opt, toAppName });
    }
    else {
        openMarket(toAppName, {
            rootTag: opt.rootTag,
            schema: _url,
            from: opt.lxFrom || opt.from,
            type: opt.lxType,
            content: opt.lxContent,
            egid: opt.lxEgid,
        });
    }
}
